import React from "react";
import { Box, Skeleton, Stack } from "@mui/material";

const TagSkeletonLoader = ({ noOfBoxes, style }) => {
  return (
    <Stack direction="row" spacing={2} sx={{}}>
      {[...Array(noOfBoxes || 12)].map((_, index) => (
        <Box key={index}>
          <Skeleton
            variant="rounded"
            width={80}
            height={32}
            sx={{ borderRadius: 10, ...style }}
          />
        </Box>
      ))}
    </Stack>
  );
};

export default TagSkeletonLoader; 